"use client";

import { c as _c } from "react/compiler-runtime";
import type { Card } from "../types";
import { CategoriesDropdown } from "./CategoriesDropdown";
import { useBlogCategory, useBlogQuery, useBlogShowAll } from "./SearchBar";
import { Wrapper, MobileOnly, PillGroup, Pill } from "data:text/javascript;base64,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";
export function Categories(t0) {
  const $ = _c(27);
  const {
    items
  } = t0;
  const [category, setCategory] = useBlogCategory();
  const [, setQuery] = useBlogQuery();
  const [, setShowAll] = useBlogShowAll();
  let t1;
  if ($[0] !== items) {
    t1 = Array.from(new Set(items.flatMap(_temp2))).sort(_temp3);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const uniqueCategories = t1;
  let t2;
  if ($[2] !== category || $[3] !== setCategory || $[4] !== setQuery || $[5] !== setShowAll) {
    t2 = item_0 => {
      if (category === item_0) {
        setCategory(null);
      } else {
        setCategory(item_0);
        setQuery(null);
        setShowAll(null);
      }
    };
    $[2] = category;
    $[3] = setCategory;
    $[4] = setQuery;
    $[5] = setShowAll;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const toggle = t2;
  let t3;
  if ($[7] !== uniqueCategories) {
    t3 = <MobileOnly><CategoriesDropdown categories={uniqueCategories} /></MobileOnly>;
    $[7] = uniqueCategories;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = !category;
  let t5;
  if ($[9] !== setCategory) {
    t5 = () => void setCategory(null);
    $[9] = setCategory;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <Pill type="button" data-selected={t4} onClick={t5}>All</Pill>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== category || $[15] !== toggle || $[16] !== uniqueCategories) {
    let t8;
    if ($[18] !== category || $[19] !== toggle) {
      t8 = item_1 => {
        const selected = category === item_1;
        return <Pill type="button" key={item_1} onClick={() => toggle(item_1)} data-selected={selected}>{item_1}</Pill>;
      };
      $[18] = category;
      $[19] = toggle;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    t7 = uniqueCategories.map(t8);
    $[14] = category;
    $[15] = toggle;
    $[16] = uniqueCategories;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <PillGroup>{t6}{t7}</PillGroup>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t3 || $[25] !== t8) {
    t9 = <Wrapper>{t3}{t8}</Wrapper>;
    $[24] = t3;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}
function _temp3(a, b) {
  return a.localeCompare(b);
}
function _temp2(item) {
  return item?.categories?.filter(_temp) ?? [];
}
function _temp(c) {
  return c !== null;
}